export const iconFontAwesomeBuildingsBuildingColumns = (
	<i className="fa-solid fa-building-columns"></i>
);
